import { GlobalWorkerOptions, getDocument } from "pdfjs-dist";
import { DateUtils } from "utils/dateutils";

const workerSrc = "/scripts/pdf.worker.min.js";
GlobalWorkerOptions.workerSrc = workerSrc;

const isUrlExpired = (fileUrl: string) => {
  const urlParams = new URLSearchParams(fileUrl);
  const date = urlParams.get("X-Amz-Date");
  if (!date) return false;
  const expireTime = urlParams.get("X-Amz-Expires");
  // AWS SigV4 emits X-Amz-Date as YYYYMMDDTHHmmssZ (no separators). The
  // default dateTimeObj format list doesn't include that shape, so pass the
  // format explicitly. dayjs is also immutable — must capture the .add()
  // return (pre-migration moment mutated in place).
  const dateTime = DateUtils.dateTimeObj(date, "YYYYMMDDTHHmmss[Z]").add(
    Number(expireTime ?? 0),
    "seconds"
  );
  const now = DateUtils.dateTimeObj();
  if (now > dateTime) {
    return true;
  }
  return false;
};

export const getPdfLoader = async ({
  fileUrl,
  onExpiredUrl,
  onProgress
}: {
  fileUrl: string;
  onExpiredUrl?: any;
  onProgress?: (...args: any[]) => any;
}) => {
  if (isUrlExpired(fileUrl)) {
    onExpiredUrl();
    return null;
  }

  const loadingTask = getDocument({
    url: fileUrl
  });

  // get progress data
  if (onProgress) loadingTask.onProgress = onProgress;

  return loadingTask.promise;
};
